'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint no-undef: "off" */
/**
 * stores app
 */
define('storesMain',['util', 'busEvent', 'getStoresListApi', 'GAReport'], function (Util, busEvent, getStoresListApi, GAReport) {
  return {
    template: '\n      <div class="page-container stores" :style="{height: height}">\n          <div class="google-maps">\n              <div id="maps2" class="store-maps-container"></div>\n          </div>\n          <div class="store-lists">\n              <div class="store-item" :class="{active: currentShow===item.id}" v-for="(item, index) in stores">\n                  <div class="store-info-container" @click="setMapView(item)">\n                      <div class="tags" v-if="item.tags && item.tags.length > 0">\n                          <div class="tag-item" v-for="(v, idx) in item.tags">{{v}}</div>\n                      </div>\n                      <div class="store-name" v-text="item.title"></div>\n                      <div class="store-star" v-if="item.score && item.score > 0">\n                          <div class="star-wrapper">\n                              <div class="dark-box">\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                              </div>\n                              <div class="light-box" :style="{ width: (item.score / 5 * 100) + \'%\' }">\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                                  <i class="xparkFonts icon-wujiaoxing" />\n                              </div>\n                          </div>\n                          <span class="score-wrapper" v-text="item.score"></span>\n                          <!--<span class="comment-count">(48)</span>-->\n                      </div>\n                      <div class="store-info">\n                          <div class="info-content">\n                              <div class="icon">\n                                  <i class="xparkFonts icon-shijian" />\n                              </div>\n                              <div class="content" v-text="item.work_time.join(\' | \')"></div>\n                          </div>\n                          <div class="info-content">\n                              <div class="icon">\n                                  <i class="xparkFonts icon-dingwei" />\n                              </div>\n                              <div class="content address-content">\n                                  <div class="address">\n                                      {{item.address}} ,{{item.city_name}}, {{item.country_name}}\n                                  </div>\n                                  <div class="distance">\n                                      <span v-if="item.distance">{{ (item.distance || 0).toFixed(2) }}km</span>\n                                  </div>\n                              </div>\n                          </div>\n                      </div>\n                  </div>\n                  <div class="store-info-action">\n                      <div class="actions">\n                          <a target="_blank" :href="item.nav_link"><i class="xparkFonts icon-dingwei1" /></a>\n                          <a v-if="item.phone" :href="item.tel_link"><i class="xparkFonts icon-dianhua" /></a>\n                          <a v-if="item.whatsapp" target="_blank" :href="item.whatsapp"><img :src="require.toUrl(\'images/whatsapp.svg\')" /></a>\n                      </div>\n                      <div class="shop_link">\n                          <a :href="item.home_page_url" v-text="i18n.visitStore" v-if="item.warehouse_id"></a>\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          visitStore: "Visit store"
        },
        map: null,
        stores: [],
        lat: 0,
        lng: 0,
        loadingGoogleMapJs: true,
        currentMarker: null,
        infoWindow: null,
        loading: false,
        currentShow: null,
        height: '90vh'
      };
    },

    components: {},
    mounted: function mounted() {
      // 定位授权
      this.getPositionPermission();
      // 店铺列表
      this.getStoreList();
      // 谷歌地图
      var thisVue = this;
      this.loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBeazbE0fS9LoTnaqdWXRKsVw86Oa823Ww").then(function (script) {
        thisVue.calculatePosition();
      });
      //
      this.resetHeight();
    },

    computed: {},
    methods: {
      getStoreList: function getStoreList() {
        var _this = this;

        getStoresListApi({}).then(function (result) {
          if (result && result.list) {
            var storesList = [];
            result.list.forEach(function (item) {
              var tmpData = item;
              var workTime = [];
              if (item.opening_hours && Array.isArray(item.opening_hours) && item.opening_hours.length > 0) {
                item.opening_hours.forEach(function (v) {
                  var tmpSting = '';
                  if (v.weekdays && Array.isArray(v.weekdays) && v.weekdays.length > 0) {
                    tmpSting = '' + v.weekdays[0];
                    if (v.weekdays.length > 1) {
                      tmpSting += '-' + v.weekdays[v.weekdays.length - 1];
                    }
                  }
                  workTime.push(tmpSting + ' ' + v.start_hour + ':' + v.start_minute + '-' + v.end_hour + ':' + v.end_minute);
                });
              }
              tmpData.work_time = workTime; //.join(" | ")
              tmpData.nav_link = 'https://www.google.com/maps/search/' + item.latitude + ',' + item.longitude;
              tmpData.tel_link = 'tel:' + item.phone;
              storesList.push(tmpData);
            });
            _this.calculatePosition(storesList);
          }
        });
      },
      setMapView: function setMapView(data) {

        if (this.currentMarker) {
          this.currentMarker.setMap(null);
          this.currentMarker = null;
        }

        var center = {
          lat: Number(data.latitude),
          lng: Number(data.longitude)
        };
        this.initMap(center);
        this.currentShow = data.id;

        // 新建当前店铺标记
        this.currentMarker = new google.maps.Marker({
          position: center,
          map: this.map,
          title: data.title
        });

        // 点击标记弹出信息
        //     this.currentMarker.addListener('click', () => {
        //       const html = `
        //   <div style="padding:8px;">
        //     <div>${data.title}</div>
        //     <div>${data.address}</div>
        //   </div>
        // `
        //       this.infoWindow.setContent(html)
        //       this.infoWindow.open(this.map, this.currentMarker)
        //     })
      },
      initMap: function initMap(center) {
        if (!this.map) {
          this.map = new google.maps.Map(document.getElementById("maps2"), {
            zoom: 17,
            center: center
          });
          this.infoWindow = new google.maps.InfoWindow();
        } else {
          this.map.setZoom(17);
          this.map.setCenter(center);
        }
      },
      loadScript: function loadScript(src) {
        return new Promise(function (resolve, reject) {
          var script = document.createElement("script");
          script.src = src;
          script.defer = "true";
          script.onload = function () {
            return resolve(script);
          };
          script.onerror = function () {
            return reject(new Error('Script load error for ' + src));
          };
          document.head.append(script);
        });
      },
      getPositionPermission: function getPositionPermission() {
        var _this2 = this;

        var that = this;
        Util.checkLocationPermission().then(function (res) {
          if (res === 'prompt') {
            busEvent.$emit('dialogModal', 'Location Permission', 'Please share your current location so we can recommend stores near you.', 'Next', _this2.getPosition);
          } else {
            // 放开
            that.getPosition();
          }
        });
      },
      getPosition: function getPosition() {
        var _this3 = this;

        var that = this;
        this.loading = true;
        Util.getCurrentLocation({ enableHighAccuracy: true, timeout: 10000 }).then(function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(position) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    that.lat = position.coords.latitude;
                    that.lng = position.coords.longitude;
                    that.loading = false;

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this3);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (err) {
          // err.code: 1=PERMISSION_DENIED, 2=POSITION_UNAVAILABLE, 3=TIMEOUT
          // if (err.code && (err.code === 2 || err.code === 3)) {
          //   that.$modal.show('getLocation')
          // } else {
          Util.getPositionWithGoogle().then(function (res) {
            that.loading = false;
            if (res.success) {
              that.lat = res.location.lat;
              that.lng = res.location.lng;
            } else {
              busEvent.$emit('modalError', 'that.i18n.locationTitle');
            }
          });
          // }
        });
      },
      calculatePosition: function calculatePosition(data) {
        var _this4 = this;

        if (this.stores.length > 0 || data && data.length > 0) {
          var stores = data || this.stores || [];
          if (stores.length < 1) return;
          var newStores = [];
          stores.forEach(function (item) {
            var tmp = item;
            if (_this4.lat && _this4.lng) {
              tmp.distance = Util.calculateDistance(item.latitude, item.longitude, _this4.lat, _this4.lng);
            } else {
              tmp.distance = '';
            }
            if (!item.home_page_url) {
              tmp.home_page_url = '/stores/index/view/id/' + item.id;
            }
            newStores.push(tmp);
          });
          newStores.sort(function (a, b) {
            return a.distance - b.distance;
          });
          this.stores = newStores;
          this.setMapView(newStores[0]);
        }
      },
      resetHeight: function resetHeight() {
        var _this5 = this;

        var timer = void 0;
        this.height = window.innerHeight + 'px';
        window.addEventListener('resize', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var navHeight = $(".in-header-quick").height() || 0;
            var titleHeight = $(".xp-navbar-container").height() || 0;
            _this5.height = window.innerHeight - navHeight - titleHeight + 'px';
          }, 200);
        });
      }
    },
    watch: {
      lat: function lat(val) {
        if (val) {
          this.calculatePosition();
        }
      }
    }
  };
});
